/**
 *  @class
 *  @function EsColorOptions
 */

class EsColorOptions extends HTMLElement {
	constructor() {
		super();
	}
	
	connectedCallback() {
		this.loadmore();
    this.customOptions();
	}

  loadmore () {
    let _this = this;
    const button = this.querySelector('.option-loadmore');

    button?.addEventListener('click', function (e) {
      this.classList.toggle("active");

      _this.querySelectorAll('.needed-active')?.forEach((el) => {
        el.classList.toggle('active');
      });
    });
  }

  customOptions() {
    let _this = this;
    const options = _this.querySelectorAll('.custom-option');

    options?.forEach(option => {
      option.addEventListener('click', function () {
        const primaryImage = this.dataset.primaryImage;
        const secondaryImage = this.dataset.secondaryImage;
        const href = this.dataset.href;
        const productCard = _this.closest('.product-card');

        if (primaryImage) {
          const primaryImageSrcset = primaryImage + " 770w";
          productCard.querySelector('.product-primary-image').setAttribute('src', primaryImage);
          productCard.querySelector('.product-primary-image').setAttribute('srcset', primaryImageSrcset);
        }

        if (secondaryImage) {
          const secondaryImageSrcset = secondaryImage + " 770w";
          productCard.querySelector('.product-secondary-image').setAttribute('src', secondaryImage);
          productCard.querySelector('.product-secondary-image').setAttribute('srcset', secondaryImageSrcset);
        }
        
        if (href) {
          productCard.querySelector('.product-featured-image-link').setAttribute('href', href);
        }
        
        this.closest('.es-color-options').querySelectorAll('.custom-option')?.forEach((el) => {
          el.classList.remove('is-selected');
        });

        this.classList.add('is-selected');
      })
    })
  }
}

customElements.define('es-color-options', EsColorOptions);
